import { Outlet, useLocation } from 'react-router-dom';
import { Sidebar } from '@/components/layout/Sidebar';
import { useAuth } from '@/lib/auth';
import { DocBreadcrumbs } from './documentation/components/DocBreadcrumbs';
import { DocNavDesktop, DocNavMobile } from './documentation/components/DocNav';
import { documentationNav } from './documentation/content';

export default function DocumentationLayout() {
  const { user } = useAuth();
  const location = useLocation();
  const currentSegment = location.pathname.replace(/^\/documentation\/?/, '');
  const currentPage =
    documentationNav.find((page) => page.path === (currentSegment || '')) ?? documentationNav[0];

  return (
    <div className="flex h-screen overflow-hidden" style={{ backgroundColor: '#F4F7FC' }}>
      <Sidebar activeItem="documentation" user={user} />

      <main id="main-content" className="flex-1 overflow-hidden">
        <div className="flex h-full flex-col xl:flex-row">
          <DocNavDesktop />

          <div className="flex flex-1 flex-col overflow-hidden">
            <DocNavMobile />
            <section className="flex-1 overflow-y-auto px-6 py-8 lg:px-10">
              <DocBreadcrumbs currentTitle={currentPage.title} />
              <div className="mt-6 pb-24">
                <Outlet />
              </div>
            </section>
          </div>
        </div>
      </main>
    </div>
  );
}
